<template>
  <svg width="46" height="46" viewBox="0 0 45 46" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.8">
      <path
        d="M0 23C0 10.5736 10.0736 0.5 22.5 0.5C34.9264 0.5 45 10.5736 45 23C45 35.4264 34.9264 45.5 22.5 45.5C10.0736 45.5 0 35.4264 0 23Z"
        fill="#0F766E"
      />
      <path
        d="M20.332 33.4226V11.8175H24.6307V33.4226H20.332ZM11.6868 24.7614V20.4627H33.2919V24.7614H11.6868Z"
        fill="white"
      />
    </g>
  </svg>
</template>
